<template>
  <div class="kpi-cards-wrapper">
    <!-- Top Row: 3 Cards -->
    <div class="kpi-row top-row">
      <!-- Active Users -->
      <div class="kpi-card">
        <div class="card-header">
          <span class="card-title">Người dùng hoạt động ({{ rangeLabel }})</span>
          <div class="icon-badge bg-green">
            <i class="fas fa-user-friends icon-green"></i>
          </div>
        </div>
        <div class="card-value">{{ kpis.activeToday || 0 }}</div>
        <div class="card-footer">
          <span class="subtext">Số người dùng hoạt động hiện tại</span>
          <span class="tag-realtime">
            <i class="fas fa-chart-line"></i> Realtime
          </span>
        </div>
      </div>

      <!-- Page Views -->
      <div class="kpi-card">
        <div class="card-header">
          <span class="card-title">Lượt xem trang ({{ rangeLabel }})</span>
          <div class="icon-badge bg-purple">
            <i class="far fa-eye icon-purple"></i>
          </div>
        </div>
        <div class="card-value">{{ kpis.totalPageViews || 0 }}</div>
        <div class="card-footer">
          <span class="subtext">Số lượt tải trang web</span>
          <span class="tag-realtime">
            <i class="fas fa-chart-line"></i> Realtime
          </span>
        </div>
      </div>

      <!-- Total Events -->
      <div class="kpi-card">
        <div class="card-header">
          <span class="card-title">Tổng số sự kiện ({{ rangeLabel }})</span>
          <div class="icon-badge bg-amber">
            <i class="fas fa-chart-bar icon-amber"></i>
          </div>
        </div>
        <div class="card-value">{{ kpis.totalVisits || 0 }}</div>
        <div class="card-footer">
          <span class="subtext">Tổng số tương tác người dùng</span>
          <span class="tag-realtime">
            <i class="fas fa-chart-line"></i> Realtime
          </span>
        </div>
      </div>
    </div>

    <!-- Middle Row: 2 Cards -->
    <div class="kpi-row middle-row">
      <!-- Search Views -->
      <div class="kpi-card">
        <div class="card-header">
          <span class="card-title">Lượt tìm kiếm ({{ rangeLabel }})</span>
          <div class="icon-badge bg-yellow">
            <i class="fas fa-search icon-yellow"></i>
          </div>
        </div>
        <div class="card-value">{{ kpis.totalSearches || 0 }}</div>
        <div class="card-footer">
          <span class="subtext">Tìm kiếm trên website</span>
          <span class="tag-realtime">
            <i class="fas fa-chart-line"></i> Realtime
          </span>
        </div>
      </div>

      <!-- QR Scans -->
      <div class="kpi-card">
        <div class="card-header">
          <span class="card-title">Lượt quét mã QR ({{ rangeLabel }})</span>
          <div class="icon-badge bg-pink">
            <i class="fas fa-qrcode icon-pink"></i>
          </div>
        </div>
        <div class="card-value">{{ kpis.totalQrScans || 0 }}</div>
        <div class="card-footer">
          <span class="subtext">Số lượt truy cập từ QR</span>
          <span class="tag-realtime">
            <i class="fas fa-chart-line"></i> Realtime
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KpiCards',
  props: {
    kpis: {
      type: Object,
      default: () => ({
        totalVisits: 0,
        activeToday: 0,
        totalPageViews: 0,
        totalSearches: 0,
        totalQrScans: 0
      })
    },
    rangeLabel: {
      type: String,
      default: '30 phút qua'
    }
  }
}
</script>

<style lang="scss" scoped>
.kpi-cards-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 24px;
}

.kpi-row {
  display: grid;
  gap: 20px;

  &.top-row {
    grid-template-columns: repeat(3, 1fr);
  }

  &.middle-row {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 992px) {
    grid-template-columns: 1fr !important;
  }
}

.kpi-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.02);
  border: 1px solid #f1f3f5;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.04);
  }

  .card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .card-title {
      font-size: 15px;
      font-weight: 700;
      color: #1f2937;
    }

    .icon-badge {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;

      &.bg-green { background: #ecfdf5; .icon-green { color: #10b981; } }
      &.bg-purple { background: #f3e8ff; .icon-purple { color: #8b5cf6; } }
      &.bg-amber { background: #fffbe6; .icon-amber { color: #d97706; } }
      &.bg-yellow { background: #fefce8; .icon-yellow { color: #eab308; } }
      &.bg-pink { background: #fce7f3; .icon-pink { color: #ec4899; } }
    }
  }

  .card-value {
    font-size: 36px;
    font-weight: 800;
    color: #111827;
    margin: 16px 0 12px 0;
    line-height: 1.1;
  }

  .card-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .subtext {
      font-size: 13px;
      color: #6b7280;
      font-weight: 500;
    }

    .tag-realtime {
      background: #e6f7f0;
      color: #10b981;
      font-size: 12px;
      font-weight: 600;
      padding: 3px 10px;
      border-radius: 20px;
      display: flex;
      align-items: center;
      gap: 4px;
    }
  }
}
</style>
